// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__3UpjW","title":"AfterBackImages_title__2XUjz","images":"AfterBackImages_images__16b6r"};